import React from 'react';
import CustomLink from 'components/CustomLink/CustomLink';
import { urls } from 'shared/constants/routing.constants';
import { CustomMuiIcon } from 'assets/images/icons/customMuiIcons';

export const Logo: React.FC = () => (
  <CustomLink
    href={urls.commonPages.home}
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      maxHeight: { lg: '56px', md: '24px', xs: '38px' },
      overflow: 'hidden',
    }}
  >
    <CustomMuiIcon type="icon-logo" sx={{ fontSize: { lg: '170px', md: '140px', xs: '0px' } }} />
    <CustomMuiIcon
      type="icon-logo-sm"
      sx={{
        fontSize: { md: '0px', xs: '57px' },
      }}
    />
  </CustomLink>
);
